import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postFileInfo: (params: FileInfoReqDto): Promise<FileInfoResDto> =>
    request({
      url: endpoints.file.info,
      method: 'post',
      data: paramsToFormData(params),
    }),
};
